var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.item.question.title))]),_c('div',{staticClass:"uploaded-photo"},[_c('img',{staticClass:"uploaded-photo__image",attrs:{"src":'https://couturme.com' + (_vm.item.answer.value || _vm.item.answer),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }